import _ from '@lodash';
import { List, ListItem, ListItemText, ListSubheader, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import React from 'react';
import { BsList } from 'react-icons/bs';
import { ImFileEmpty, ImFilePdf, ImFilePicture, ImFileText2 } from 'react-icons/im';
import { MdLabel } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ArquivoActions';


const Conditions = [
    { "id": 1, "label": "Documentos", "icon": "assignment", "valor": "text/plain" },
    { "id": 2, "label": "Imagens", "icon": "photo", "valor": "image/jpg" },
    { "id": 3, "label": "PDF's", "icon": "pdf", "valor": "application/pdf" },
]

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: 8,
    },
    item: {
        height: 40,
        borderRadius: '0 20px 20px 0',
        paddingRight: 12,
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon': {
                color: 'inherit'
            }
        },
        '&.square, &.active.square': {
            width: '100%',
            borderRadius: '0'
        },
        '& .list-item-icon': "folder",
        '& .list-item-text': {},
        color: theme.palette.text.primary,
        textDecoration: 'none!important'
    }
});

class ArquivoLeftSidebar extends XAPPComponent {

    state = {
        filter: '',
        tag: ''
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!_.isEqual(prevState.filter, this.state.filter)) || (!_.isEqual(prevState.tag, this.state.tag))) {
            this.props.setcondicoes(this.state);
        }
    }

    setConditions = (_AName, _AValue) => {
        var obj = this.state[_AName];
        var response = "";
        if (!_.isUndefined(obj) && !_.isNull(obj) && obj.length > 0 && this.IsExist(_AName, _AValue)) {
            obj.split(',').forEach(item => {
                if (item !== _AValue.toString()) {
                    response = response.length > 0 ? response + "," + item : item.toString();
                }
            });
            this.setState({ [_AName]: response });
        }
        else {
            response = obj.length > 0 ? obj + "," + _AValue : _AValue.toString();
            this.setState({ [_AName]: response });
        }
    }

    IsExist = (_AName, _AValue) => {
        var AExist = false;
        var obj = this.state[_AName];
        if (!_.isUndefined(obj) && !_.isNull(obj) && obj.length > 0) {
            obj.split(',').forEach(item => {
                if (_AValue.toString().includes(item)) {
                    AExist = true;
                }
            });
        }
        return AExist;
    }

    getIcon = (_AIcon) => {
        switch (_AIcon) {
            case 'pdf': return <ImFilePdf className="text-20" />
            case 'photo': return <ImFilePicture className="text-20" />
            case 'assignment': return <ImFileText2 className="text-20" />
            case 'file': return <ImFileEmpty className="text-20" />
            default: return <div />
        }
    }

    render() {
        const { classes, Tags } = this.props;

        return (
            <div className="flex-auto">
                <List>
                    <ListSubheader className={classes.listSubheader} disableSticky>FILTROS</ListSubheader>
                    <ListItem
                        button
                        activeClassName="active"
                        className={classNames(classes.item, 'list-item', 'list-item-icon', this.state.filter.length < 1 && 'active')}

                        key={"ListItemTodos"}
                        onClick={() => {
                            this.setState({ filter: '' });
                        }}
                    >
                        <BsList className="text-20" />
                        <ListItemText primary={"Todos"} disableTypography={true} />
                    </ListItem>

                    {Conditions.map((item) => (
                        <ListItem
                            button
                            activeClassName="active"
                            className={classNames(classes.item, 'list-item', 'list-item-icon', this.IsExist("filter", item.valor) && 'active')}

                            key={item.id}
                            onClick={() => {
                                this.setConditions("filter", item.valor);
                            }}
                        >
                            {this.getIcon(item.icon)}
                            <ListItemText primary={item.label} disableTypography={true} />
                        </ListItem>
                    ))}
                </List>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {}
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ArquivoLeftSidebar)));
